import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import {
  negate13xrbakfwasjy as negate,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  modulooi4g1kq3dmtt as modulo,
} from '../js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getProgressionLastElement(start, end, step) {
  var tmp;
  if (step > 0) {
    tmp = start >= end ? end : end - differenceModulo(end, start, step) | 0;
  } else if (step < 0) {
    tmp = start <= end ? end : end + differenceModulo(start, end, -step | 0) | 0;
  } else {
    throw IllegalArgumentException().a1('Step is zero.');
  }
  return tmp;
}
function getProgressionLastElement_0(start, end, step) {
  var tmp;
  if (step > 0n) {
    tmp = start >= end ? end : subtract(end, differenceModulo_0(end, start, step));
  } else if (step < 0n) {
    tmp = start <= end ? end : add(end, differenceModulo_0(start, end, negate(step)));
  } else {
    throw IllegalArgumentException().a1('Step is zero.');
  }
  return tmp;
}
function differenceModulo(a, b, c) {
  return mod(mod(a, c) - mod(b, c) | 0, c);
}
function differenceModulo_0(a, b, c) {
  return mod_0(subtract(mod_0(a, c), mod_0(b, c)), c);
}
function mod(a, b) {
  var mod = a % b | 0;
  return mod >= 0 ? mod : mod + b | 0;
}
function mod_0(a, b) {
  var mod = modulo(a, b);
  return mod >= 0n ? mod : add(mod, b);
}
//region block: exports
export {
  getProgressionLastElement as getProgressionLastElement2w30kdy2w5nkt,
  getProgressionLastElement_0 as getProgressionLastElement4s9ggap3esy2,
};
//endregion

//# sourceMappingURL=progressionUtil.mjs.map
